import React from 'react';
import axios from 'axios';

import Loading from '../Components/Loading';

import { getCaseStyle, formatNull } from '../Utils/GlobalUtils';

import styles from '../styles/DynamicModal.module.css';

const UsersCase = ({ id }) => {
    const [limitForView, setLimitForView] = React.useState(10);
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);
        axios.get(`/api/get-cases-user?id=${id}&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            setWarning('');
            setCases(response.data);
            setVisibilityBtn(response.data.length >= limitForView);
        })
        .catch(error => {
            setWarning(error.response.data.message || error.message);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, id]);

    return (
    <>
        <h2>Найденные карточки:</h2>
        {loading ? <Loading /> 
        : warning ? <a>{warning}</a>
        : cases.map((caseItem) => (
            <div className={styles.userCardLine} style={getCaseStyle(caseItem.date_end, caseItem.status)} key={caseItem.id} onClick={(e) => {e.preventDefault(); window.open(`/case/${caseItem.id}`, '_blank');}}>
                <a>{formatNull(caseItem.number)}</a>
                <a>{formatNull(caseItem.internal_number)}</a>
                <a>{formatNull(caseItem.applicant)}</a>
            </div>
        ))}
        {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center', margin: '5px 0'}}><button type='button' className='miniButton' onClick={() => {setLimitForView(prev => prev + 10); setReload(true)}}>Загрузить ещё</button></span>}
    </>
    )
}

export default UsersCase;